import { Form, Formik, FormikHelpers } from "formik"
import { toast } from "react-toastify"
import { AxiosError } from "axios"
import { IClientModel, IHttpErrorResponseModel } from "@common-models/*"
import { CONST_HTTP_CUSTOM_CODE_FORM_VALIDATION_ERROR } from "@common-constants/*"
import MyAlert from "@common-utils/MyAlert"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"
import React from "react"
import MyInputField from "@common-utils/fields/MyInputField"
import * as Yup from "yup"
import { IAddClientRequestModel } from "./core/_models"
import { addClientRequest } from "./core/_requests"

const AddClientForm = ({ callback = () => {} }: IAddClientFormPropsModel) => {
     // Schema
     const schema = Yup.object().shape({
          nom: Yup.string().required().nullable().label(`"Dénomination sociale"`),
     })

     // Init values
     const initialValues: IAddClientRequestModel = {}

     // Handle submit
     function handleSubmit(values: IAddClientRequestModel, helpers: FormikHelpers<IAddClientRequestModel>) {
          helpers.setStatus(null)

          addClientRequest(values)
               .then(r => {
                    toast.success("Le client a bien été ajouté")

                    callback(r.data)
               })
               .catch((e: AxiosError) => {
                    const error: IHttpErrorResponseModel = e.response?.data

                    // Set form errors
                    if (error?.code === CONST_HTTP_CUSTOM_CODE_FORM_VALIDATION_ERROR && error?.errors) {
                         for (const key in error.errors) helpers.setFieldError(key, error.errors[key])
                    }

                    // Set form global status and notify user using a toast
                    helpers.setStatus(error?.detail)
                    toast.error(error?.detail, { autoClose: false })

                    // Stop submit loader
                    helpers.setSubmitting(false)
               })
     }

     return (
          <>
               <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={schema}>
                    {helpers => {
                         return (
                              <Form noValidate autoComplete="off">
                                   {helpers.status && (
                                        <MyAlert type={"danger"} classNames={"mb-4"}>
                                             {helpers.status}
                                        </MyAlert>
                                   )}

                                   {/* Titre */}
                                   <div className="row mb-5">
                                        <label className="col-lg-4 col-form-label fw-bold fs-6 required">Dénomination sociale</label>

                                        <div className="col-lg-8">
                                             <MyInputField
                                                  name={"nom"}
                                                  value={helpers.values.nom}
                                                  onChange={val => helpers.setFieldValue("nom", val)}
                                                  placeholder={"Dénomination sociale"}
                                                  isInvalid={!!helpers.errors.nom}
                                                  autoFocus={true}
                                             />
                                             <div className={"mb-2"}>{helpers.errors.nom && <div className={"text-danger"}>{helpers.errors.nom}</div>}</div>
                                        </div>
                                   </div>

                                   {/* Submit button */}
                                   <div className={"d-flex justify-content-end"}>
                                        <button className={"btn btn-sm btn-primary d-inline-flex align-items-center"} type={"submit"} disabled={helpers.isSubmitting}>
                                             {!helpers.isSubmitting ? <>Ajouter</> : <MySimpleSpinner size={"sm"} />}
                                        </button>
                                   </div>
                              </Form>
                         )
                    }}
               </Formik>
          </>
     )
}

interface IAddClientFormPropsModel {
     callback?: (val: IClientModel) => void
}

export default AddClientForm
